import { useQuery } from '@tanstack/react-query';

import axios from 'axios';
import { GET_APP_VERSION } from '@/constants';
import { AppVersionResponse } from '@/types';

export const useGetAppVersion = () =>
  useQuery({
    queryKey: ['app-version'],
    queryFn: () =>
      axios.get<AppVersionResponse>(GET_APP_VERSION).then((res) => {
        return res.data;
      }),
    refetchOnWindowFocus: false,
    staleTime: 0,
  });
